import _typeof from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import store from '@/store';
import dayjs from 'dayjs';
import context from '@/main';
var STORAGEPREFIX = 'weforsys_';
var STORAGETYPE = window.localStorage;
var weforsys = {
  toDateText: function toDateText(dateTimeStamp) {
    var result = '';
    var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var halfamonth = day * 15;
    var month = day * 30;
    var now = new Date().getTime(); //获取当前时间毫秒
    var diffValue = now - dateTimeStamp; //时间差
    if (diffValue < 0) return "刚刚";
    var minC = diffValue / minute; //计算时间差的分，时，天，周，月
    var hourC = diffValue / hour;
    var dayC = diffValue / day;
    var weekC = diffValue / week;
    var monthC = diffValue / month;
    if (monthC >= 1 && monthC <= 3) {
      result = " " + parseInt(monthC) + "月前";
    } else if (weekC >= 1 && weekC <= 3) {
      result = " " + parseInt(weekC) + "周前";
    } else if (dayC >= 1 && dayC <= 6) {
      result = " " + parseInt(dayC) + "天前";
    } else if (hourC >= 1 && hourC <= 23) {
      result = " " + parseInt(hourC) + "小时前";
    } else if (minC >= 1 && minC <= 59) {
      result = " " + parseInt(minC) + "分钟前";
    } else if (diffValue >= 0 && diffValue <= minute) {
      result = "刚刚";
    } else {
      var datetime = new Date();
      datetime.setTime(dateTimeStamp);
      var Nyear = datetime.getFullYear();
      var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
      var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
      var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
      result = Nyear + "-" + Nmonth + "-" + Ndate;
    }
    return result;
  },
  getDate: function getDate(format, strInterval, number) {
    var myDate = new Date();
    var dtTmp = new Date();
    if (!!strInterval) {
      switch (strInterval) {
        case 's':
          myDate = new Date(Date.parse(dtTmp) + 1000 * number); // 秒
          break;
        case 'n':
          myDate = new Date(Date.parse(dtTmp) + 60000 * number); // 分
          break;
        case 'h':
          myDate = new Date(Date.parse(dtTmp) + 3600000 * number); // 小时
          break;
        case 'd':
          myDate = new Date(Date.parse(dtTmp) + 86400000 * number); // 天
          break;
        case 'w':
          myDate = new Date(Date.parse(dtTmp) + 86400000 * 7 * number); // 星期
          break;
        case 'q':
          myDate = new Date(dtTmp.getFullYear(), dtTmp.getMonth() + number * 3, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds()); // 季度
          break;
        case 'm':
          myDate = new Date(dtTmp.getFullYear(), dtTmp.getMonth() + number, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds()); // 月
          break;
        case 'y':
          myDate = new Date(dtTmp.getFullYear() + number, dtTmp.getMonth(), dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds()); // 年
          break;
        default:
      }
    }
    return weforsys.toDate(myDate, format);
  },
  toDate: function toDate(v, format) {
    format = format ? format : "yyyy-MM-dd HH:mm";
    if (!v) return "";
    var d = v;
    if (typeof v === 'string') {
      if (v.indexOf("/Date(") > -1) d = new Date(parseInt(v.replace("/Date(", "").replace(")/", ""), 10));else d = new Date(Date.parse(v.replace(/-/g, "/").replace("T", " ").split(".")[0]));
    } else {
      d = new Date(v);
    }
    var o = {
      "M+": d.getMonth() + 1,
      "d+": d.getDate(),
      "h+": d.getHours(),
      "H+": d.getHours(),
      "m+": d.getMinutes(),
      "s+": d.getSeconds(),
      "q+": Math.floor((d.getMonth() + 3) / 3),
      "S": d.getMilliseconds()
    };
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return format;
  },
  getThatDay: function getThatDay(space) {
    if (space == undefined) {
      space = 0;
    }
    var date = new Date();
    date.setTime(date.getTime() + 86400000 * space);
    return this.assemblyDay({
      year: date.getFullYear(),
      month: date.getMonth(),
      date: date.getDate()
    });
  },
  assemblyDay: function assemblyDay(data) {
    var year = data.year.toString();
    data.month = Number(data.month + 1);
    var month = this.complement(data.month);
    var date = this.complement(data.date);
    return year + '-' + month + '-' + date;
  },
  complement: function complement(value, digit) {
    digit = digit ? digit : 2;
    value = Number(value);
    if (value < Math.pow(10, digit - 1)) {
      var text = '';
      for (var i = 0; i < digit - value.toString().length; i++) {
        text = text + '0';
      }
      return text + value;
    } else {
      return value.toString();
    }
  },
  toTreeViewJson: function toTreeViewJson(data, id, parentIdText, idText) {
    parentIdText = parentIdText ? parentIdText : 'parentId';
    idText = idText ? idText : 'id';
    id = id ? id : 0;
    var treeJson = [];
    var childNode = data.filter(function (v) {
      return v[parentIdText] == id;
    });
    if (childNode.length > 0) {
      var _loop = function _loop(i) {
        var treeModel = _objectSpread(_objectSpread({}, childNode[i]), {}, {
          hasChildren: !!data.filter(function (v) {
            return v[parentIdText] == childNode[i][idText];
          }).length,
          ChildNodes: weforsys.toTreeViewJson(data, childNode[i][idText], parentIdText, idText),
          isexpand: childNode[i].isexpand == undefined ? true : childNode[i].isexpand,
          complete: true
        });
        treeJson.push(treeModel);
      };
      for (var i = 0; i < childNode.length; i++) {
        _loop(i);
      }
    }
    return treeJson;
  },
  toFileSize: function toFileSize(size) {
    if (size == null || size == "") {
      return "";
    }
    if (size < 1024.00) return weforsys.toDecimal(size) + " 字节";else if (size >= 1024.00 && size < 1048576) return weforsys.toDecimal(size / 1024.00) + " KB";else if (size >= 1048576 && size < 1073741824) return weforsys.toDecimal(size / 1024.00 / 1024.00) + " MB";else if (size >= 1073741824) return weforsys.toDecimal(size / 1024.00 / 1024.00 / 1024.00) + " GB";
  },
  toDecimal: function toDecimal(num) {
    if (num == null) {
      num = "0";
    }
    num = num.toString().replace(/\$|\,/g, '');
    if (isNaN(num)) num = "0";
    var sign = num == (num = Math.abs(num));
    num = Math.floor(num * 100 + 0.50000000001);
    var cents = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10) cents = "0" + cents;
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) num = num.substring(0, num.length - (4 * i + 3)) + '' + num.substring(num.length - (4 * i + 3));
    return (sign ? '' : '-') + num + '.' + cents;
  },
  toUrl: function toUrl(url) {
    return process.env.VUE_APP_BASE_API + url;
  },
  getAuth: function getAuth() {
    return store.getters.token;
  },
  // 基于dayjs日期格式化,时间戳(毫秒)转日期
  dateFormat: function dateFormat(date, format) {
    format = format || 'YYYY-MM-DD HH:mm';
    if (!date) return '';
    return dayjs(date).format(format);
  },
  // 基于dayjs日期格式化,日期转时间戳(毫秒)
  timestamp: function timestamp(val) {
    return dayjs(val).valueOf();
  },
  // 基于dayjs日期格式化, 表格专用
  tableDateFormat: function tableDateFormat(row, column, cellValue) {
    var format = 'YYYY-MM-DD HH:mm';
    if (!cellValue) return '';
    return dayjs(cellValue).format(format);
  },
  storageSet: function storageSet(obj) {
    for (var i in obj) {
      cacheItem(i, obj[i]);
    }
    function cacheItem(key, val) {
      key = STORAGEPREFIX + key;
      var valType = _typeof(val);
      if (val !== null) {
        var valConstructor = val.constructor;
      }
      if (valType === 'string' || valType === 'number' || valType === 'boolean') {
        if (valConstructor === String) {
          val = val + '|String';
        } else if (valConstructor === Number) {
          val = val + '|Number';
        } else if (valConstructor === Boolean) {
          val = val + '|Boolean';
        }
        STORAGETYPE.setItem(key, val);
      } else if (valType === 'object') {
        if (val === null) {
          val = JSON.stringify(val) + '|Null';
          STORAGETYPE.setItem(key, val);
        } else {
          if (valConstructor === Array) {
            val = JSON.stringify(val) + '|Array';
          } else if (valConstructor === Object) {
            val = JSON.stringify(val) + '|Object';
          }
          STORAGETYPE.setItem(key, val);
        }
      }
    }
  },
  storageGet: function storageGet(key) {
    key = STORAGEPREFIX + key;
    var keyName = STORAGETYPE.getItem(key);
    if (keyName === null) {
      return null;
    }
    var valArr = keyName.split('|');
    var getDataType = valArr[valArr.length - 1];
    valArr.splice(valArr.length - 1, 1);
    var val = valArr.join('');
    if (getDataType === 'Number') {
      val = parseInt(val);
    } else if (getDataType === 'Boolean') {
      if (val === 'true') {
        val = true;
      } else {
        val = false;
      }
    } else if (getDataType === 'Array' || getDataType === 'Object' || getDataType === 'Null') {
      val = JSON.parse(val);
    }
    return val;
  },
  storageRemove: function storageRemove(key) {
    STORAGETYPE.removeItem(STORAGEPREFIX + key);
  },
  storageClear: function storageClear() {
    for (var i in STORAGETYPE) {
      if (i.indexOf(STORAGEPREFIX) !== -1) {
        STORAGETYPE.removeItem(i);
      }
    }
  },
  hasP: function hasP(enCode) {
    var permissionList = store.getters && store.getters.permissionList;
    var modelId = context.$route.meta.modelId || '';
    if (!modelId) return false;
    var list = permissionList.filter(function (o) {
      return o.modelId === modelId;
    });
    if (!list.length) return false;
    var columnList = list[0] && list[0].column ? list[0].column : [];
    if (!columnList.length) return false;
    var hasPermission = columnList.some(function (column) {
      return column.enCode === enCode;
    });
    if (hasPermission) return true;
    return false;
  },
  hasFormP: function hasFormP(enCode) {
    var permissionList = store.getters && store.getters.permissionList;
    var modelId = context.$route.meta.modelId || '';
    if (!modelId) return false;
    var list = permissionList.filter(function (o) {
      return o.modelId === modelId;
    });
    if (!list.length) return false;
    var formList = list[0] && list[0].form ? list[0].form : [];
    if (!formList.length) return false;
    var hasPermission = formList.some(function (form) {
      return form.enCode === enCode;
    });
    if (hasPermission) return true;
    return false;
  },
  hasBtnP: function hasBtnP(enCode) {
    var permissionList = store.getters && store.getters.permissionList;
    var modelId = context.$route.meta.modelId || '';
    if (!modelId) return false;
    var list = permissionList.filter(function (o) {
      return o.modelId === modelId;
    });
    if (!list.length) return false;
    var btnList = list[0] && list[0].button ? list[0].button : [];
    if (!btnList.length) return false;
    var hasPermission = btnList.some(function (btn) {
      return btn.enCode === enCode;
    });
    if (hasPermission) return true;
    return false;
  }
};
export default weforsys;